import React, {Component} from 'react';
import {Card, Header, Icon, Image} from 'semantic-ui-react';
import {Link} from "react-router-dom";

class CardDash extends Component {
    render() {
        return (
            <Card as={Link} to={this.props.url}>
                <Card.Content>
                    <Header as='h3' icon>
                        <Icon><Image src={this.props.icon} height={48} alt='logo'/></Icon>
                        {this.props.name}
                    </Header>
                </Card.Content>
            </Card>
        );
    }
}
export default CardDash;



// WEBPACK FOOTER //
// ./src/components/extras/CardDash.js